import ScriptingEffect from './ScriptingEffect.js';
import {pipe} from './pipe.js';
import {
    execute,
    notes,
    steps,
    prob,
} from './lang.js';
import {repeat} from './beat.js';

class BeatRepeat extends ScriptingEffect {
    constructor(track) {
        super("Beat Repeat", track);
        this.newVar('repeats', 1, 0, 16);
        this.newVar('rate', 2, 0, 16);
        this.clear();
    }

    get documentation() {
        return ["Repeats any triggers"];
    }

    isRealTime() {
        return false;
    }

    clear() {
        this.myScript = pipe(
            repeat(this.var('repeats'), this.var('rate')));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track, ignoreId=true) {
        let fx = new BeatRepeat(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}


export default BeatRepeat;
